import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { styles, colors } from '../../styles/theme';
import { useIsMobile } from '../../hooks';
import { AppStoreBadge } from '../AppStoreBadge';

export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const isMobile = useIsMobile(768);
  const location = useLocation();

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  React.useEffect(() => {
    if (!isMobile) {
      setMobileMenuOpen(false);
    }
  }, [isMobile]);

  const isActive = (path) => location.pathname === path;

  const navLinkStyle = (path) => ({
    ...styles.navLink,
    color: isActive(path) ? colors.text : colors.textMuted,
    fontWeight: isActive(path) ? '600' : '500',
  });

  return (
    <header style={styles.header}>
      <nav style={styles.nav} onKeyDown={event => { if (event.key === 'Escape') closeMobileMenu(); }}>
        <Link to="/" style={{ ...styles.logo, display: 'flex', alignItems: 'center', gap: '0.6rem' }} onClick={closeMobileMenu}>
          <img
            src="/logo-96.webp"
            alt="Bhol"
            width={36}
            height={36}
            style={{
              width: '36px',
              height: '36px',
              borderRadius: '8px'
            }}
          />
          <span>Bhol</span>
        </Link>

        {/* Hamburger Menu */}
        <button
          type="button"
          aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={mobileMenuOpen}
          aria-controls="main-navigation"
          style={{
            ...styles.hamburger,
            width: 44,
            height: 44,
            alignItems: 'center',
            justifyContent: 'center',
            padding: 0,
            border: 0,
            background: 'transparent',
            borderRadius: 8,
            display: isMobile ? 'flex' : 'none'
          }}
          onClick={toggleMobileMenu}
        >
          <div style={{
            ...styles.hamburgerLine,
            transform: mobileMenuOpen ? 'rotate(45deg) translate(5px, 5px)' : 'none'
          }} />
          <div style={{
            ...styles.hamburgerLine,
            opacity: mobileMenuOpen ? 0 : 1
          }} />
          <div style={{
            ...styles.hamburgerLine,
            transform: mobileMenuOpen ? 'rotate(-45deg) translate(5px, -5px)' : 'none'
          }} />
        </button>

        {/* Desktop & Mobile Nav */}
        <ul id="main-navigation" style={isMobile ? (mobileMenuOpen ? styles.navLinksOpen : { display: 'none' }) : styles.navLinks}>
          <li>
            <Link
              to="/"
              style={navLinkStyle('/')}
              onClick={closeMobileMenu}
              onMouseEnter={(e) => e.target.style.color = colors.text}
              onMouseLeave={(e) => { if (!isActive('/')) e.target.style.color = colors.textMuted; }}
            >
              Home
            </Link>
          </li>
          <li>
            <Link
              to="/pro"
              style={navLinkStyle('/pro')}
              onClick={closeMobileMenu}
              onMouseEnter={(e) => e.target.style.color = colors.text}
              onMouseLeave={(e) => { if (!isActive('/pro')) e.target.style.color = colors.textMuted; }}
            >
              Pro
            </Link>
          </li>
          <li>
            <Link
              to="/about"
              style={navLinkStyle('/about')}
              onClick={closeMobileMenu}
              onMouseEnter={(e) => e.target.style.color = colors.text}
              onMouseLeave={(e) => { if (!isActive('/about')) e.target.style.color = colors.textMuted; }}
            >
              About
            </Link>
          </li>
          <li>
            <a
              href="/blog"
              style={navLinkStyle('/blog')}
              onClick={closeMobileMenu}
              onMouseEnter={(e) => e.target.style.color = colors.text}
              onMouseLeave={(e) => { if (!isActive('/blog')) e.target.style.color = colors.textMuted; }}
            >
              Blog
            </a>
          </li>
          <li>
            <Link
              to="/careers"
              style={navLinkStyle('/careers')}
              onClick={closeMobileMenu}
              onMouseEnter={(e) => e.target.style.color = colors.text}
              onMouseLeave={(e) => { if (!isActive('/careers')) e.target.style.color = colors.textMuted; }}
            >
              Careers
            </Link>
          </li>
          <li>
            <AppStoreBadge location="header_nav" size="small" />
          </li>
        </ul>
      </nav>

      {/* Overlay */}
      {mobileMenuOpen && isMobile && (
        <div style={styles.overlay} onClick={closeMobileMenu} />
      )}
    </header>
  );
}

export default Header;
